export default {
	title: "New custom template",
	saveButton: "Save template",
	cancelButton: "Cancel",

	nameFieldHint: "",
	nameFieldLabel: "Template name",
	nameFieldPlaceholder: "e.g. ‘My custom template’",

	descriptionFieldHint: "",
	descriptionFieldLabel: "Template description",
	descriptionFieldOptionalLabel: "Optional",
	descriptionFieldPlaceholder: "What is this template for?",

	categoryFieldHint: "",
	categoryFieldLabel: "Save to",
};
